var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.item.url)?_c('span',[_vm._v(_vm._s(_vm.item.title))]):(_vm.item.new_window)?_c('a',{attrs:{"href":_vm.item.url,"target":"_blank"}},[_vm._v(" "+_vm._s(_vm.item.title))]):_c('NuxtLink',{attrs:{"to":_vm.item.url}},[_vm._v("\n        "+_vm._s(_vm.item.title)+"\n    ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }